import blogs_2019 from './2019'
import blogs_2020 from './2020'
import blogs_2021 from './2021'

export default [
    ...blogs_2019,
    ...blogs_2020,
    ...blogs_2021,
]